const LEGACY_SHORT_DATE = /^(\d{2})\s*\.\s*(\d{1,2})\s*\.\s*(\d{1,2})\.?$/

const buildUtcDate = (year: number, month: number, day: number) => {
  const date = new Date(Date.UTC(year, month - 1, day))

  return date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
    ? date
    : undefined
}

/**
 * SEO 날짜 계약용 파서.
 *
 * 백엔드의 과도기 표시 형식 `yy. m. d`는 20yy의 날짜로 해석한다.
 * 시간 정보가 없는 날짜이므로 UTC 자정으로 고정해 서버 지역에 따른 날짜 이동을 막는다.
 */
export const parseSeoDate = (value?: string) => {
  const normalized = value?.trim()
  if (!normalized) return undefined

  const legacy = normalized.match(LEGACY_SHORT_DATE)
  if (legacy) {
    return buildUtcDate(
      2000 + Number(legacy[1]),
      Number(legacy[2]),
      Number(legacy[3]),
    )
  }

  const date = new Date(normalized)
  return Number.isNaN(date.getTime()) ? undefined : date
}

export const toIsoSeoDate = (value?: string) => parseSeoDate(value)?.toISOString()
